import { Component } from '@angular/core';
import { FmntsEmptyStateModule } from '@fmnts/components/empty-state';
import { FmntsIconsModule } from '@fmnts/components/icons';
import { I18nModule } from '@fmnts/i18n';
import { faCircleQuestion } from '@fortawesome/pro-solid-svg-icons';

@Component({
  selector: 'supporter-feedback-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  imports: [FmntsEmptyStateModule, FmntsIconsModule, I18nModule],
})
export class SupportFeedbackNotFoundComponent {
  /** @internal */
  protected readonly _iconNotFound = faCircleQuestion;
}
